

















  import { Vue, Component, Prop } from 'vue-property-decorator'
  import { CMS } from '@one/types'
  import FooterItem = CMS.Footer.FooterListItem;
  import OneCmsGridLinkComponent from '~/components/molecules/links/OneCmsGridLinkComponent.vue'

  @Component({
    components: { OneCmsGridLinkComponent },
  })
  export default class OneFooterListItem extends Vue {
    @Prop({
      type: Object,
    })
    item!: FooterItem;
  }
